import "../../TargetReport/TableContent/index.css";
import * as S from "./formStyle";
import AnchorsLogoOptions from './AnchorsLogoOptions'
import DatePicker, { registerLocale } from "react-datepicker";
import React, { useState, useEffect } from "react";
import api from "../../../../services/api";
import excelIcon from "../../../../assets/images/excel48.png";
import { Button, Tooltip, NativeSelect, Paper } from "@material-ui/core";
import { toast } from "react-toastify";
import { useMessageBox } from "../../../../context/MessageBox";
import { useParams } from "react-router-dom";

function OperationsMiddle({
  setTableData,
  setTotalizarColuna,
  setIsLoading,
  isLoading,
  selectedAnchor,
  triggerUpdate,
  anchors,
  handleSelectAnchor
}) {
  const classes = S.useStyles();
  const getInitialDate = () => {
    const mes = new Date().getMonth() - 6;
    const ano = new Date().getFullYear();

    return new Date(ano, mes, 1);
  };

  const getFinalDate = () => {
    const mes = new Date().getMonth() + 1;
    const ano = new Date().getFullYear();

    return new Date(ano, mes, 0);
  };

  const [initialDate, setInitialDate] = useState(getInitialDate());
  const [finalDate, setFinalDate] = useState(getFinalDate());
  const [report, setReport] = useState();
  const screenParams = {
    title: "Relatório Acumulado Rede",
    apiTable: "Relatorios/Relatorio009AcumuladoRede",
    apiDownloadExcel: "Relatorios/Relatorio009AcumuladoRedeDownloadExcel",
    dateFormat: "MM/yyyy",
  };

  const { setMessageData } = useMessageBox();

  useEffect(async () => {
    if (initialDate && finalDate && triggerUpdate && selectedAnchor) {
      await getInfoForForm();
    }
  }, [initialDate, finalDate, selectedAnchor]);

  const getInfoForForm = async () => {
    const model = {
      ancoraId: selectedAnchor.ancoraId ? selectedAnchor.ancoraId : 0,
      plataformaId: selectedAnchor.plataformaId ? selectedAnchor.plataformaId : 0,
      mesInicial: {
        mes: new Date(initialDate).getMonth() + 1,
        ano: new Date(initialDate).getFullYear(),
      },
      mesFinal: {
        mes: new Date(finalDate).getMonth() + 1,
        ano: new Date(finalDate).getFullYear(),
      },
    };
    setReport(model);
    setIsLoading(true);
    try {
      const relatorio = await api.post(screenParams.apiTable, model);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== "Sucesso") {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
      } else {
        setTableData(relatorio.data.resposta.itens);
        setTotalizarColuna(relatorio.data.resposta.totalizadorLinha);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const exportTable = async () => {
    if (!report) {
      return;
    }
    setIsLoading(true);

    try {
      const relatorio = await api.post(screenParams.apiDownloadExcel, report);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== "Sucesso") {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      const a = document.createElement("a");
      a.href =
        "data:" +
        relatorio.data.resposta.contentType +
        ";base64," +
        relatorio.data.resposta.fileContents;
      a.download = relatorio.data.resposta.fileDownloadName;
      a.click();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div style={{ height: "100%" }}>
        <div
          className='new-body-schedule'
          style={{
            justifyContent: "space-between",
            display: "flex",
            marginTop: "20px",
            alignItems: "center"
          }}>
          <div style={{ minWidth: '20%' }}>
            <AnchorsLogoOptions
              anchors={anchors}
              handleSelectAnchor={handleSelectAnchor}
              selectedAnchor={selectedAnchor}
            />
          </div>
          <div className='schedule-input'
            style={{ display: 'flex', marginTop: '8px', alignItems: 'center',  flexDirection: 'column' }}
          >
            <span className={classes.label}>Mês/Ano Inicial: </span>
            <div style={{ display: "flex", alignItems: 'center' }}>
              <Button
                value={initialDate}
                style={{
                  minWidth: "20px",
                  width: "20px",
                  height: "23px",
                  paddingLeft: "20px",
                }}
                onClick={() => {
                  const newDate = new Date(initialDate);
                  setInitialDate(newDate.setMonth(newDate.getMonth() - 1));
                }}>
                🢀
              </Button>

              <div
                style={{
                  padding: "0px 5px",
                  maxWidth: "150px",
                  height: "23px",
                }}>
                <DatePicker
                  selected={initialDate}
                  maxDate={finalDate}
                  onChange={(date) => {
                    setInitialDate(date);
                  }}
                  dateFormat={screenParams.dateFormat}
                  locale='ptBR'
                />
              </div>

              <Button
                style={{ minWidth: "20px", width: "20px", height: "23px" }}
                onClick={() => {
                  const newDate = new Date(initialDate);
                  const dateToCompare = new Date(
                    newDate.getFullYear(),
                    newDate.getMonth() + 1,
                    0
                  );
                  if (dateToCompare < finalDate) {
                    setInitialDate(newDate.setMonth(newDate.getMonth() + 1));
                  }
                }}>
                🢂
              </Button>
            </div>
          </div>
          <div className='schedule-input'
            style={{ display: 'flex', marginTop: '8px', alignItems: 'center',  flexDirection: 'column' }}
          >
            <span>Mês/Ano Final: </span>
            <div style={{ display: "flex", alignItems: 'center' }}>
              <Button
                style={{
                  minWidth: "20px",
                  width: "20px",
                  height: "23px",
                  paddingLeft: "20px",
                }}
                onClick={() => {
                  const newDate = new Date(finalDate);
                  const dateToCompare = new Date(
                    newDate.getFullYear(),
                    newDate.getMonth(),
                    0
                  );
                  if (dateToCompare > initialDate) {
                    setFinalDate(newDate.setMonth(newDate.getMonth() - 1));
                  }
                }}>
                🢀
              </Button>

              <div
                style={{
                  padding: "0px 5px",
                  maxWidth: "150px",
                  height: "23px",
                }}>
                <DatePicker
                  selected={finalDate}
                  minDate={initialDate}
                  onChange={(date) => {
                    setFinalDate(date);
                  }}
                  dateFormat={screenParams.dateFormat}
                  locale='ptBR'
                />
              </div>

              <Button
                style={{ minWidth: "20px", width: "20px", height: "23px" }}
                onClick={() => {
                  const newDate = new Date(finalDate);
                  setFinalDate(newDate.setMonth(newDate.getMonth() + 1));
                }}>
                🢂
              </Button>
            </div>
          </div>
          <div>
            <img
              src={excelIcon}
              onClick={() => {
                exportTable();
              }}
              style={{ cursor: "pointer", marginRight: "8px" }}></img>
          </div>
        </div>
      </div>
    </>
  );
}

export default OperationsMiddle;
